import React from "react";
import Icon from "../Icon";

export default props => (
  <Icon viewBox="0 0 32 32" {...props}>
    <path d="M4 16l8 8L28 8" fill="none" />
  </Icon>
);
